import React, { useEffect, useState } from "react";

import "./Cookie.css";

const Cookie = () => {
  const [cookie, setCookie] = useState(true);

  function Accept() {
    localStorage.setItem("setCookie", "0");
    setCookie(false);
  }
  function Decline() {
    localStorage.setItem("setCookie", "1");
    setCookie(false);
  }

  return (
    <>
      {!window.location.pathname.includes("/auth/google/callback") &&
        !window.location.pathname.includes("/auth/facebook/callback") &&
        !window.location.pathname.includes("/auth") && (
          <>
            {cookie ? (
              <div className="mainCookieDiv">
                <div className="cookieContent">
                  <div className="content">
                    <span
                      style={{
                        fontSize: 20,
                        fontWeight: 700,
                        marginBottom: 10,
                      }}
                    >
                      Your Cookie Settings
                    </span>
                    <p style={{ fontWeight: 500 }}>
                      We use cookies to offer you a better experience, analyze
                      site traffic, and serve targeted advertisements. <br />
                      By continuing to use this website, you consent to the use
                      of cookies in accordance with our Cookie Policy.
                    </p>
                  </div>
                  <div className="Btn_div">
                    <div className="accept" onClick={() => Accept()}>
                      Accept
                    </div>
                    <div className="decline" onClick={() => Decline()}>
                      Decline
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </>
        )}
    </>
  );
};

export default Cookie;
